


































































































import CellLine from '../components/CellLine.vue'
import Alert from '../components/Alert.vue'
import { Vue, Component } from 'vue-property-decorator'
import { XInput, XButton, XTextarea, Datetime, Keyboard, popup } from '@lx-frontend/cvux'
import UploadImg from '../leaveRegister/components/UploadImg.vue'
import { LeaveInfo, CommonSelectItem, ExitRuleItem, StepNoStatus, ExitingRuleStepItem } from './indexType'
import OutTipsPopuop from './compoents/OutTipsPopuop.vue'
import CarTypePopup from './compoents/CarTypePopup.vue'
import OutRulesPopup from './compoents/OutRulesPopup.vue'
import EmployeePopup from './compoents/EmployeePopup.vue'
import util from '@/common/util'
import { CarStatus } from '@/common/commonType'

const throttle = require('lodash.throttle')

@Component({
  components: {
    CellLine,
    XInput,
    popup,
    XButton,
    XTextarea,
    Datetime,
    Keyboard,
    UploadImg,
    OutTipsPopuop,
    CarTypePopup,
    OutRulesPopup,
    EmployeePopup,
    Alert
  }
})
export default class Index extends Vue {
  leaveInfo:LeaveInfo = {
    vin: '',
    phone_number: '',
    exiting_rule_id: null,
    exiting_rule_name: '',
    steps: [],
    remark: '',
    exit_category_id: null,
    image_urls: [],
    brand_id: null,
    brand_name: ''
  }

  canSubmit = true

  alertInfo = {
    title: '',
    text: ''
  }

  StepNoStatus = StepNoStatus

  exitingRules: ExitRuleItem[] = []

  exitingRuleSteps: ExitingRuleStepItem[] = []

  isHasCarErr = false // 车架号是否在审核中

  isHasMobileErr = false // 手机号是否在审核中

  selfBrands: CommonSelectItem[] = []

  reasonOptions: CommonSelectItem[] = []

  handleConfirm = throttle(this.handleConfirmSubmit.bind(this), 1000, {
    leading: true,
    trailing: false
  });

  selfStepsInfo:{
    index: number,
    employeeList: CommonSelectItem[],
    selEmployeeIds: number[],
  } = {
    index: 0,
    employeeList: [],
    selEmployeeIds: []
  }

  get exitCategoryName() {
    const i = this.reasonOptions.find(item => item.id === this.leaveInfo.exit_category_id)
    return i ? i.name : ''
  }

  created() {
    this.init()
  }

  async init() {
    this.switchLoading({ status: true, text: '加载中...' })
    this.initRoute()
    await Promise.all([this.getExitCategories(), this.getSelfBrands(), this.getUnlicensedExitInfo()])
    this.switchLoading({ status: false })
  }

  initRoute() {
    const { vin = '', phone_number = '', brand_id = '' } = this.$route.query
    this.leaveInfo = {
      ...this.leaveInfo,
      vin: vin as string,
      phone_number: phone_number as string,
      brand_id: (brand_id === '' ? null : +brand_id) as number
    }
  }

  carTypeShow: boolean = false

  handleShowReasonOptions() {
    // @ts-ignore
    this.$refs.outTipsPopup.changeShow(true)
  }

  handelShowCarTypePopup() {
    // @ts-ignore
    this.$refs.carTypePopup.changeShow(true)
  }

  async getExitCategories() {
    const { code, data } = await this.$rest.barriergate.getExitCategories()
    if (code !== 0) return
    const list = data.exit_categories
    this.reasonOptions = list
    this.leaveInfo.exit_category_id = list[0].id
  }

  deleteRepetition(arr: CommonSelectItem[]) {
    const newArr = []
    const arrId = []
    for (let item of arr) {
      if (arrId.indexOf(item['id']) === -1) {
        arrId.push(item['id'])
        newArr.push(item)
      }
    }
    return newArr
  }

  async getSelfBrands() {
    const { code, brands } = await this.$rest.carInfo.getCarBrandList()
    if (code !== 0) return

    const allBrands = Object.values(brands)

    this.selfBrands = this.deleteRepetition(allBrands.flat() as CommonSelectItem[])

    if (this.leaveInfo.brand_id) {
      const findI = this.selfBrands.find(brand => brand.id === this.leaveInfo.brand_id)
      if (findI) {
        this.leaveInfo.brand_name = findI.name
        return
      }
    }
    this.leaveInfo.brand_id = this.selfBrands[0].id
    this.leaveInfo.brand_name = this.selfBrands[0].name
  }

  async getUnlicensedExitInfo(ruleId?: number) {
    const params:any = {}
    if (ruleId) params.exiting_rule_id = ruleId
    this.switchLoading({ status: true, text: '加载中...' })
    const { code, data } = await this.$rest.barriergate.getUnlicensedExitInfo(params)
    this.switchLoading({ status: false })
    if (code !== 0) return
    const { exiting_rules = [], exiting_rule_steps = [] } = data
    // 不传ID请求第一步
    if (!ruleId) {
      this.exitingRules = exiting_rules
      if (exiting_rules.length === 1) {
        this.leaveInfo.exiting_rule_id = exiting_rules[0].rule_id
        this.leaveInfo.exiting_rule_name = exiting_rules[0].rule_name
        this.getUnlicensedExitInfo(exiting_rules[0].rule_id)
      }
      return
    }
    // 传入id请求第二步
    this.exitingRuleSteps = exiting_rule_steps.map((step: any, index: number) => {
      let selEmployee = []
      let selEmployeeIds: number[] = []
      if (step.step_no === StepNoStatus.SPONSOR && index === 0) {
        // 发起人
        selEmployee = step.review_employee_choices
        selEmployeeIds = [step.review_employee_choices[0].employee_id] as number[]
      }
      step.selEmployee = selEmployee
      step.selEmployeeIds = selEmployeeIds
      return step
    })
  }

  handleShowOutRules() {
    if (this.exitingRules.length <= 1) return
    // @ts-ignore
    this.$refs.outRulesPopup.changeShow(true)
  }

  // 选择审核人
  handleOnSelect(index: number, stepNo:number) {
    if (stepNo === StepNoStatus.SPONSOR) return
    const employeeList = (
      this.exitingRuleSteps[index]['review_employee_choices'] as { employee_id: number; employee_name: string }[]
    ).map((i) => ({
      id: +i.employee_id,
      name: i.employee_name
    }))
    this.selfStepsInfo = {
      index,
      employeeList,
      selEmployeeIds: this.exitingRuleSteps[index]['selEmployeeIds']
    }
    this.$nextTick(() => {
      // @ts-ignore
      this.$refs.employeePopup.changeShow(true)
    })
  }

  handleSubmitEmployeeSelect(ids: number[]) {
    const { index } = this.selfStepsInfo
    this.selfStepsInfo.selEmployeeIds = ids
    // @ts-ignore
    this.exitingRuleSteps[index]['selEmployeeIds'] = ids
    // @ts-ignore
    let employeeList = this.exitingRuleSteps[index].review_employee_choices
    // @ts-ignore
    this.exitingRuleSteps[index]['selEmployee'] = employeeList.filter((v: { employee_id: number }) => {
      return ids.indexOf(v.employee_id) > -1
    })
  }

  valid() {
    // 车架号和手机号是否必填取决于无牌放行规则设置
    const {
      vin,
      phone_number,
      exiting_rule_id,
      exit_category_id,
      brand_id
    } = this.leaveInfo

    if (vin && !util.regexpMap.regexp_car_vin.test(vin)) {
      util.showToast('请输入正确的车架号')
      return false
    }
    if (phone_number && !util.regexpMap.regexp_mobile.test(phone_number)) {
      util.showToast('请输入正确的客户手机号')
      return false
    }

    if (brand_id === null) {
      util.showToast('请选择车辆品牌')
      return false
    }

    if (!exiting_rule_id) {
      util.showToast('请选择放行流程')
      return false
    }

    const { vin_required, phone_number_required } = this.exitingRules.find(rule => rule.rule_id === exiting_rule_id) as ExitRuleItem

    if (vin_required && !vin) {
      util.showToast('车架号必填')
      return false
    }

    if (phone_number_required && !phone_number) {
      util.showToast('客户手机号必填')
      return false
    }

    // 步骤列表检查
    const noReviewer = this.exitingRuleSteps.find((v, index) => {
      return (index > 0) && (!v.selEmployee || v.selEmployee.length === 0)
    })
    if (noReviewer) {
      this.showToast(`${noReviewer.title}缺少审核人, 请选择`)
      return false
    }

    if (exit_category_id === null) {
      this.showToast('请选择放行备注')
      return false
    }

    if (this.isHasCarErr || this.isHasMobileErr) {
      this.alertInfo = {
        title: '提示',
        text: this.isHasCarErr ? '车架号已在放行审核' : '手机号已在放行审核'
      }
      // @ts-ignore
      this.$refs.alertRef.changeShow(true)
      return false
    }
    return true
  }

  async uploadImg() {
    if (this.leaveInfo.image_urls.length === 0) return []
    // 上传图片
    // 1、先传微信
    const mediaIds = await Promise.all(this.leaveInfo.image_urls.map((localId) => {
      return new Promise((resolve) => {
        this.$wechat.wx.uploadImage({
          isShowProgressTips: 0,
          localId,
          success: (res: any) => resolve(res.serverId),
          fail: () => {
            this.switchLoading({ status: false })
            this.showToast('图片上传失败，请稍后重试')
            this.canSubmit = true
          }
        })
      })
    }))
    // 2、再传后端，拿到图片绝对地址
    const { code, data, message } = await this.$rest.wx.getLeaveStoreImage({ media_ids: mediaIds })
    if (code !== 0) {
      this.canSubmit = true
      this.switchLoading({ status: false })
      this.showToast(message)
      return
    }

    return JSON.stringify(data.map((item: any) => item.upload_image))
  }

  async handleConfirmSubmit() {
    if (!this.valid() || !this.canSubmit) return
    this.canSubmit = false
    const params:any = { ...this.leaveInfo }
    delete params.exiting_rule_name
    params.vin = params.vin.toLocaleUpperCase()
    const steps: { rule_step_id: number; step_no: number; title: string; review_employee_ids: number[] }[] = []
    this.exitingRuleSteps.forEach(item => {
      steps.push({
        rule_step_id: +item.step_id,
        step_no: +item.step_no,
        title: item.title,
        review_employee_ids: item.selEmployeeIds
      })
    })
    params.steps = steps
    this.switchLoading({ status: true, text: '提交中...' })
    params.image_urls = await this.uploadImg()
    const { code, message } = await this.$rest.barriergate.createUnlicensedCarExiting(params)
    this.canSubmit = true
    this.switchLoading({ status: false })
    if (code !== 0) {
      this.alertInfo = {
        title: '提示',
        text: message || '请求错误，请稍后'
      }
      // @ts-ignore
      this.$refs.alertRef.changeShow(true)
      return
    }
    this.$router.push({
      path: '/new/back/page',
      query: {
        status: 'success',
        tips: '已提交',
        title: '发起成功',
        backLink: '/storeVehicle/index'
      }
    })
  }

  handleSelectOutTips(o: CommonSelectItem) {
    this.leaveInfo.exit_category_id = o.id
  }

  handleSelectCarType(o: CommonSelectItem) {
    const { id, name } = o
    this.leaveInfo.brand_id = id
    this.leaveInfo.brand_name = name
  }

  handleSelectOutRules(exitingRuleItem: ExitRuleItem) {
    this.leaveInfo = {
      ...this.leaveInfo,
      exiting_rule_id: exitingRuleItem.rule_id,
      exiting_rule_name: exitingRuleItem.rule_name
    }
    this.getUnlicensedExitInfo(exitingRuleItem.rule_id)
  }

  handleDeleteImg(index: number) {
    this.leaveInfo.image_urls.splice(index, 1)
  }

  handleAddImg(localIds: string[]) {
    this.leaveInfo.image_urls = this.leaveInfo.image_urls.concat(localIds)
  }

  handleBlur(val: string, type: 'vin' | 'mobile') {
    if (!val) return
    const regMap = {
      vin: util.regexpMap.regexp_car_vin,
      mobile: util.regexpMap.regexp_mobile
    }
    const tipsMap = {
      vin: '请输入正确的车架号',
      mobile: '请输入正确的手机号'
    }
    if (!regMap[type].test(val)) {
      util.showToast(tipsMap[type])
      return
    }
    this.getVinInfo(val, type)
  }

  async getVinInfo(val: string, type: string) {
    // 这里要做个分辨
    const str = type === 'vin' ? 'vin' : 'phone_number'
    const params = {
      [str]: val
    }
    const { code, data } = await this.$rest.barriergate.getUnlicensedCarExiting(params)
    if (code !== 0) return
    const { can_recreate = false } = data || {}
    if (!can_recreate) {
      util.showToast(`${type === 'vin' ? '车架号' : '手机号'}已在放行审核`)
      type === 'vin' ? this.isHasCarErr = true : this.isHasMobileErr = true
    }
  }
}
